import { computed } from 'vue';
import { useRootStore } from '@/stores';
import { STAGE } from '@/consts/stage';
import { useIsStageNavigationEnabled } from '@/composables/useAdminStage';

/**
 * Composable for handling stage indicator functionality
 * @returns {Object} Stage indicator data
 */
export function useStageIndicator() {
    const rootStore = useRootStore();
    const isVisible = useIsStageNavigationEnabled();

    // Get the current stage name
    const stageName = computed(() => {
        const stageId = rootStore.selectedStageId;
        const selectedStage = STAGE[stageId];
        if (selectedStage) {
            return selectedStage.name;
        }

        return '';
    });

    return {
        stageName,
        showIndicator: isVisible
    };
}
